export const types = {
  googleMap: {
    COMPLETED_LOAD: 'googleMap/COMPLETED_LOAD',
  },
  router: {
    LOCATION_CHANGE: '@@router/LOCATION_CHANGE',
  },

  window: {
    RESIZE: 'window/RESIZE'
    
  },

  auth0: {
    CREATED_AUTH0_CLIENT: 'auth0/CREATED_AUTH0_CLIENT',
    CHANGED_AUTH_STATE: 'auth0/CHANGED_AUTH_STATE',
  },

  signUpCard: {
    ENABLED: 'signUpCard/ENABLED',
    DISABLED: 'signUpCard/DISABLED',
    CHANGED_TEXT: 'signUpCard/CHANGED_TEXT',
  },

  leftMenuBar: {
    OPEN: 'leftMenuBar/OPEN',
    CLOSE: 'leftMenuBar/CLOSE',
  },

  userMenu: {
    OPEN: 'userMenu/OPEN',
    CLOSE: 'userMenu/CLOSE', 
  },

  titleGrid: {
    menu: {
      OPEN: 'titleGrid/menu/OPEN',
      CLOSE: 'titleGrid/menu/CLOSE',
    },
  },

  user: {
    UNMOUNT: 'user/UNMOUNT',
    RECEIVE_USER_PROFILE: 'user/RECEIVE_USER_PROFILE',
    CHANGED_TAB: 'user/CHANGED_TAB',
  },

  settings: {
    RECEIVE_SETTINGS: 'settings/RECEIVE_SETTINGS',
    RESPONSE_UPLOAD_AVATAR: 'settings/RESPONSE_UPLOAD_AVATAR',
    RESPONSE_UPLOAD_HEADER: 'settings/RESPONSE_UPLOAD_HEADER',
    RESPONSE_UPDATE: 'settings/RESPONSE_UPDATE',
  },
  
  accountSettingsCard: {
    INIT: 'accountSettingsCard/INIT',
    UNMOUNT: 'accountSettingsCard/UNMOUNT',
    CHANGED_PHOTO: 'accountSettingsCard/CHANGED_PHOTO',
    CHANGED_TEXT: 'accountSettingsCard/CHANGED_TEXT',
    RESPONSE_UPLOAD_AVATAR: 'accountSettingsCard/RESPONSE_UPLOAD_AVATAR',
    RESPONSE_UPLOAD_HEADER: 'accountSettingsCard/RESPONSE_UPLOAD_HEADER',
    RESPONSE_UPDATE_DISPLAYNAME: 'accountSettingsCard/RESPONSE_UPDATE_DISPLAYNAME',
    RESPONSE_UPDATE: 'accountSettingsCard/RESPONSE_UPDATE',
    START_SAVE: 'accountSettingsCard/START_SAVE',
    END_SAVE: 'accountSettingsCard/END_SAVE',
  },
  
  boardSettingsCard: {
    CHANGED_SWITCH: 'boardSettingsCard/CHANGED_SWITCH',
  },

  webBoard: {
    INIT: 'webBoard/INIT',
    REFRESH: 'webBoard/REFRESH',
    fileTitleCard: {
      CHANGED_MODE: 'webBoard/fileTitleCard/CHANGED_MODE'
    },
    confirmDialog: {
      OPEN: 'webBoard/confirmDialog/OPEN',
      CLOSE: 'webBoard/confirmDialog/CLOSE',
      CHANGED_TEXT: 'webBoard/confirmDialog/CHANGED_TEXT',      
    },
  },

  storeBoardCard: {
    UNMOUNT: 'storeBoardCard/UNMOUNT',
    recordMenu: {
      EDIT: 'storeBoardCard/recordMenu/EDIT',
    }
  },

  renjuBoardCard: {
    RESIZE_BOARD: 'renjuBoardCard/RESIZE_BOARD',
    CLOSE: 'renjuBoardCard/CLOSE',
    ANALYZE_MODE_ON: 'renjuBoardCard/ANALYZE_MODE_ON',
    ANALYZE_MODE_OFF: 'renjuBoardCard/ANALYZE_MODE_OFF',
    MARK_MODE_ON: 'renjuBoardCard/MARK_MODE_ON',
    MARK_MODE_OFF: 'renjuBoardCard/MARK_MODE_OFF',
    CHANGED_INSERT_STRINGS: 'renjuBoardCard/CHANGED_INSERT_STRINGS',
    REMOVE_MARK: 'renjuBoardCard/REMOVE_MARK',
    CHANGED_STONE_TYPE: 'renjuBoardCard/CHANGED_STONE_TYPE',
    SELECTED_TURN_MENU: 'renjuBoardCard/CHANGED_TURN_MENU',
    SELECTED_EDIT_MODE: 'renjuBoardCard/SELECTED_EDIT_MODE',
    SELECTED_OPERATION_MODE: 'selectedIndex/SELECTED_OPERATION_MODE',
    CLICK_RENJU_BOARD: 'renjuBoardCard/CLICK_RENJU_BOARD',
    RIGHT_CLICK_RENJU_BOARD: 'renjuBoardCard/RIGHT_CLICK_RENJU_BOARD',
    SPECIFIED_WIDTH_ON: 'renjuBoardCard/SPECIFIED_WIDTH_ON',
    SPECIFIED_WIDTH_OFF: 'renjuBoardCard/SPECIFIED_WIDTH_OFF',
    CHANGED_GAME_INFO: 'renjuBoardCard/CHANGED_GAME_INFO',
    CHANGED_PUZZLE_INFO: 'renjuBoardCard/CHANGED_PUZZLE_INFO',
    CHANGED_SETTINGS: 'renjuBoardCard/CHANGED_SETTINGS',
    OPEN_ANALYZE_TAB: 'renjuBoardCard/OPEN_ANALYZE_TAB',
    CHANGED_SWAP: 'renjuBoardCard/CHANGED_SWAP',
    DECISION: 'renjuBoardCard/DECISION',
    CHANGED_FIVE_MOVE_NUMBER: 'renjuBoardCard/CHANGED_FIVE_MOVE_NUMBER',
    OPEN_MESSAGE: 'renjuBoardCard/OPEN_MESSAGE',
    CLOSE_MESSAGE: 'renjuBoardCard/CLOSE_MESSAGE',
  },

  editModeMenu: {
    OPEN: 'editModeMenu/OPEN',
    CLOSE: 'editModeMenu/CLOSE',
    confirmDialog: {
      OPEN: 'editModeMenu/confirmDialog/OPEN',
      CLOSE: 'editModeMenu/confirmDialog/CLOSE',
    },
  },

  operationModeMenu: {
    OPEN: 'operationModeMenu/OPEN',
    CLOSE: 'operationModeMenu/CLOSE',
  },

  renjuBoardMenu: {
    OPEN: 'renjuBoardMenu/OPEN',
    CLOSE: 'renjuBoardMenu/CLOSE',
    CLICKED_MENU: 'renjuBoardMenu/CLICKED_MENU',
    ANALYZE_MODE_ON: 'renjuBoardMenu/ANALYZE_MODE_ON',
    MARK_MODE_ON: 'renjuBoardMenu/MARK_MODE_ON',
  },
  
  turnSelectMenu: {
    OPEN: 'turnSelectMenu/OPEN',
    CLOSE: 'turnSelectMenu/CLOSE',
  },

  controlButtons: {
    START_PLAY: 'controlButtons/START_PLAY',
    STOP_PLAY: 'controlButtons/STOP_PLAY',
    SKIP_PREVIOUS: 'controlButtons/SKIP_PREVIOUS',
    FAST_REWIND: 'controlButtons/FAST_REWIND',
    FAST_FORWARD: 'controlButtons/FAST_FORWARD',
    SKIP_NEXT: 'controlButtons/SKIP_NEXT',
  },
  
  shareDialog: {
    OPEN: 'shareDialog/OPEN',
    CLOSE: 'shareDialog/CLOSE',
    MAKED_URL: 'shareDialog/MAKED_URL',
  },

  settingsDialog: {
    OPEN: 'settingsDialog/OPEN',
    CLOSE: 'settingsDialog/CLOSE',
    INITIALIZE: 'settingsDialog/INITIALIZE',
    CHANGED_CHECKBOX: 'settingsDialog/CHANGED_CHECKBOX',
  },

  gameInfoDialog: {
    OPEN: 'gameInfoDialog/OPEN',
    CLOSE: 'gameInfoDialog/CLOSE',
    INITIALIZE: 'gameInfoDialog/INITIALIZE',
    CHANGED_TEXT: 'gameInfoDialog/CHANGED_TEXT',
  },

  puzzleInfoDialog: {
    OPEN: 'puzzleInfoDialog/OPEN',
    CLOSE: 'puzzleInfoDialog/CLOSE',
    INITIALIZE: 'puzzleInfoDialog/INITIALIZE',
    CHANGED_TEXT: 'puzzleInfoDialog/CHANGED_TEXT',
  },

  tweetDialog: {
    OPEN: 'tweetDialog/OPEN',
    CLOSE: 'tweetDialog/CLOSE',
    MAKED_URL: 'tweetDialog/MAKED_URL',
    DEFAULT_TEXT: 'tweetDialog/DEFAULT_TEXT',
    CHANGED_HASHTAGS: 'tweetDialog/CHANGED_HASHTAGS',
    CHANGED_TEXT: 'tweetDialog/CHANGED_TEXT',
    CHANGED_CHECKBOX: 'tweetDialog/CHANGED_CHECKBOX',
    TWEET: 'tweetDialog/TWEET',
  },

  tweetListDialog: {
    OPEN: 'tweetListDialog/OPEN',
    CLOSE: 'tweetListDialog/CLOSE',
    CHANGED_PAGE: 'tweetListDialog/CHANGED_PAGE',
    CHANGED_ROWS_PER_PAGE: 'tweetListDialog/CHANGED_ROWS_PER_PAGE',
    OPEN_CONFIRM_DIALOG: 'tweetListDialog/OPEN_CONFIRM_DIALOG',
    CLOSE_CONFIRM_DIALOG: 'tweetListDialog/CLOSE_CONFIRM_DIALOG',
  },

  downloadImageDialog: {
    OPEN: 'downloadImageDialog/OPEN',
    CLOSE: 'downloadImageDialog/CLOSE',
  },

  comment: {
    RESPONSE_ADD: 'comment/RESPONSE_ADD',
    RESPONSE_DELETE: 'comment/RESPONSE_DELETE',
    RESPONSE_SELECT: 'comment/RESPONSE_SELECT',
    REQUEST_SELECT: 'comment/REQUEST_SELECT',
  },

  // Event
  eventCard: {
    MOUNT: 'eventCard/MOUNT',
    UNMOUNT: 'eventCard/UNMOUNT',
    REQUEST_SELECT: 'eventCard/REQUEST_SELECT',
    RESPONSE_SELECT: 'eventCard/RESPONSE_SELECT',
  },

  eventListCard: {
    REQUEST_SELECT_EVENT: 'eventListCard/REQUEST_SELECT_EVENT',
    RESPONSE_SELECT_EVENT: 'eventListCard/RESPONSE_SELECT_EVENT',
  },

  eventRegister: {
    CHANGED_TEXT: 'eventRegister/CHANGED_TEXT',
    CHANGED_DATETIME: 'eventRegister/CHANGED_DATETIME',
    CHANGED_GEO_CODE: 'eventRegister/CHANGED_GEO_CODE',
    CHANGED_LATLNG: 'eventRegister/CHANGED_LATLNG',
    CHANGED_PHOTO: 'eventRegister/CHANGED_PHOTO',
    CHANGED_CHECKBOX: 'eventRegister/CHANGED_CHECKBOX',
    DELETE_ADDRESS: 'eventRegister/DELETE_ADDRESS',
    REGISTER: 'eventRegister/REGISTER',
    RESPONSE_ADD_EVENT: 'eventRegister/RESPONSE_ADD_EVENT',
    RESPONSE_SELECT_EVENT: 'eventRegister/RESPONSE_SELECT_EVENT',
  },

  // LivePage
  liveList: {
    CHANGE_VIEW_MODE: 'liveList/CHANGE_VIEW_MODE',
    CLEAR_BOARD_CONTEXT: 'liveList/CLEAR_BOARD_CONTEXT',
    CLEAR_PAGE_NAVIGATION: 'liveList/CLEAR_PAGE_NAVIGATION',
    NEXT_PAGE: 'liveList/NEXT_PAGE',
    BACK_PAGE: 'liveList/BACK_PAGE',
  },

  liveSettings: {
    INIT: 'liveSettings/INIT',
    CHANGED_TEXT: 'liveSettings/CHANGED_TEXT',
  },

  liveGame: {
    OPEN_CONFIRM_DIALOG: 'liveGame/OPEN_CONFIRM_DIALOG',
    CLOSE_CONFIRM_DIALOG: 'liveGame/CLOSE_CONFIRM_DIALOG',
    CHANGE_TAB: 'liveGame/CHANGE_TAB',
  },

  chatCard: {
    CHANGED_TEXT: 'chatCard/CHANGED_TEXT',
    OPEN_BOARD: 'chatCard/OPEN_BOARD',
  },

  chatMenu: {
    OPEN: 'chatMenu/OPEN',
    CLOSE: 'chatMenu/CLOSE',
    SELECTED_MENU: 'chatMenu/SELECTED_MENU',
    HIDE_CHAT_CARD: 'chatMenu/HIDE_CHAT_CARD',
    SHOW_CHAT_CARD: 'chatMenu/SHOW_CHAT_CARD',
  },

  userListDialog: {
    OPEN: 'userListDialog/OPEN',
    CLOSE: 'userListDialog/CLOSE',
  },

  // PuzzlePage
  puzzleHome: {
    RESET: 'puzzleHome/RESET',
    menu: {
      OPEN: 'puzzleHome/menu/OPEN',
      CLOSE: 'puzzleHome/menu/CLOSE',
    },
    pageNavigation: {
      NEXT_PAGE: 'puzzleHome/pageNavigation/NEXT_PAGE',
      BACK_PAGE: 'puzzleHome/pageNavigation/BACK_PAGE',
      CLEAR: 'puzzleHome/pageNavigation/CLEAR',
    }
  },

  puzzleRegister: {
    INIT: 'puzzleRegister/INIT',
    NEXT: 'puzzleRegister/NEXT',
    BACK: 'puzzleRegister/BACK',
    BACK_FIRST: 'puzzleRegister/BACK_FIRST',
    SELECTED_STEP: 'puzzleRegister/SELECTED_STEP',
    CHANGED_TEXT: 'puzzleRegister/CHANGED_TEXT',
    CHANGED_CHECKBOX: 'puzzleRegister/CHANGED_CHECKBOX',
    ADD_TAG: 'puzzleRegister/ADD_TAG',
    REMOVE_TAG: 'puzzleRegister/REMOVE_TAG',
    RESPONSE_SELECT_PUZZLE: 'puzzleRegister/RESPONSE_SELECT_PUZZLE',
    confirmDialog: {
      OPEN: 'puzzleRegister/confirmDialog/OPEN',
      CLOSE: 'puzzleRegister/confirmDialog/CLOSE',
    }
  },

  puzzleViewer: {
    INITIALIZE: 'puzzleViewer/INITIALIZE',
    OPEN: 'puzzleViewer/OPEN',
    CHANGED_TEXT: 'puzzleViewer/CHANGED_TEXT',
    CHANGED_CHECKBOX: 'puzzleViewer/CHANGED_CHECKBOX',
    REQUEST_SELECT_PUZZLE: 'puzzleViewer/REQUEST_SELECT_PUZZLE',
    RESPONSE_SELECT_PUZZLE: 'puzzleViewer/RESPONSE_SELECT_PUZZLE',
    comment: {
      OPEN_BOARD: 'puzzleViewer/comment/OPEN_BOARD',
      CLOSE_BOARD: 'puzzleViewer/comment/CLOSE_BOARD',
    },
    confirmDialog: {
      OPEN: 'puzzleViewer/confirmDialog/OPEN',
      CLOSE: 'puzzleViewer/confirmDialog/CLOSE',
    },
  },

  puzzleListCard: {
    UNMOUNT: 'puzzleListCard/UNMOUNT',
    CHANGED_URL_PARAMS: 'puzzleListCard/CHANGED_URL_PARAMS',
    REQUEST_SELECT_PUZZLE: 'puzzleListCard/REQUEST_SELECT_PUZZLE',
    RESPONSE_SELECT_PUZZLE: 'puzzleListCard/RESPONSE_SELECT_PUZZLE',
    menu: {
      OPEN: 'puzzleListCard/menu/OPEN',
      CLOSE: 'puzzleListCard/menu/CLOSE',
    },
  },

  gameRoomListCard: {
    CHANGED_GROUP: 'gameRoomListCard/CHANGED_GROUP',
  },

  gameRoom: {
    CLEAR_CHAT: 'gameRoom/CLEAR_CHAT',
    CLEAR_ROOM: 'gameRoom/CLEAR_ROOM',
  },

  snackbar: {
    NOTIFY: 'snackbar/NOTIFY',
    CLOSE: 'snackbar/CLOSE',
  },

  lib: {
    RESPONSE_CREATE_BOARD_IMAGE: 'lib/RESPONSE_CREATE_BOARD_IMAGE',
    CLEAR_DOWNLOAD_IMAGE: 'lib/CLEAR_DOWNLOAD_IMAGE',
  },

  bitly: {
    REQUEST_MAKE_SHORT_URL: 'bitly/REQUEST_MAKE_SHORT_URL',
    RECEIVE_MAKE_SHORT_URL: 'bitly/RECEIVE_MAKE_SHORT_URL',
    CLEAR_SHORT_URL: 'bitly/CLEAR_SHORT_URL'
  },

  twitter: {
    REQUEST_TWEET: 'twitter/REQUEST_TWEET',
    RECEIVE_TWEET: 'twitter/RECEIVE_TWEET',
    REQUEST_GET_SCHEDULE_TWEET_LIST: 'twitter/REQUEST_GET_SCHEDULE_TWEET_LIST',
    RECEIVE_GET_SCHEDULE_TWEET_LIST: 'twitter/RECEIVE_GET_SCHEDULE_TWEET_LIST',
    CLEAR_SCHEDULE_TWEET_LIST: 'twitter/CLEAR_SCHEDULE_TWEET_LIST',
    REQUEST_DELETE_SCHEDULE_TWEET: 'twitter/REQUEST_DELETE_SCHEDULE_TWEET',
    RECEIVE_DELETE_SCHEDULE_TWEET: 'twitter/RECEIVE_DELETE_SCHEDULE_TWEET',
  },

  fetch: {
    media: {
      REQUEST_UPLOAD: 'fetch/media/REQUEST_UPLOAD',
      RESPONSE_UPLOAD: 'fetch/media/RESPONSE_UPLOAD',
    },
    user: {
      REQUEST_ADD: 'fetch/user/REQUEST_ADD',
      RESPONSE_ADD: 'fetch/user/RESPONSE_ADD',
      REQUEST_UPDATE: 'fetch/user/REQUEST_UPDATE',
      RESPONSE_UPDATE: 'fetch/user/RESPONSE_UPDATE',
      REQUEST_SELECT: 'fetch/user/REQUEST_SELECT',
      RESPONSE_SELECT: 'fetch/user/RESPONSE_SELECT',
      REQUEST_DELETE: 'fetch/user/REQUEST_DELETE',
      RESPONSE_DELETE: 'fetch/user/RESPONSE_DELETE',
      REQUEST_CREDENTIAL: 'fetch/user/REQUEST_CREDENTIAL',
      RESPONSE_CREDENTIAL: 'fetch/user/RESPONSE_CREDENTIAL',
      REQUEST_SETTINGS: 'fetch/user/REQUEST_SETTINGS',
      RESPONSE_SETTINGS: 'fetch/user/RESPONSE_SETTINGS',
    },
    board: {
      REQUEST_ADD: 'fetch/board/REQUEST_ADD',
      RESPONSE_ADD: 'fetch/board/RESPONSE_ADD',
      REQUEST_UPDATE: 'fetch/board/REQUEST_UPDATE',
      RESPONSE_UPDATE: 'fetch/board/RESPONSE_UPDATE',
      REQUEST_SELECT: 'fetch/board/REQUEST_SELECT',
      RESPONSE_SELECT: 'fetch/board/RESPONSE_SELECT',
      REQUEST_DELETE: 'fetch/board/REQUEST_DELETE',
      RESPONSE_DELETE: 'fetch/board/RESPONSE_DELETE',
    },
    puzzle: {
      REQUEST_ADD: 'fetch/puzzle/REQUEST_ADD',
      RESPONSE_ADD: 'fetch/puzzle/RESPONSE_ADD',
      REQUEST_UPDATE: 'fetch/puzzle/REQUEST_UPDATE',
      RESPONSE_UPDATE: 'fetch/puzzle/RESPONSE_UPDATE',
      REQUEST_SELECT: 'fetch/puzzle/REQUEST_SELECT',
      RESPONSE_SELECT: 'fetch/puzzle/RESPONSE_SELECT',
      REQUEST_DELETE: 'fetch/puzzle/REQUEST_DELETE',
      RESPONSE_DELETE: 'fetch/puzzle/RESPONSE_DELETE',
      REQUEST_SELECTED_GOOD: 'fetch/puzzle/REQUEST_SELECTED_GOOD',
      RESPONSE_SELECTED_GOOD: 'fetch/puzzle/RESPONSE_SELECTED_GOOD',
      REQUEST_SELECTED_BAD: 'fetch/puzzle/REQUEST_SELECTED_BAD',
      RESPONSE_SELECTED_BAD: 'fetch/puzzle/RESPONSE_SELECTED_BAD',
      REQUEST_ADD_COMMENT: 'fetch/puzzle/REQUEST_ADD_COMMENT',
      RESPONSE_ADD_COMMENT: 'fetch/puzzle/RESPONSE_ADD_COMMENT',
      REQUEST_DELETE_COMMENT: 'fetch/puzzle/REQUEST_DELETE_COMMENT',
      RESPONSE_DELETE_COMMENT: 'fetch/puzzle/RESPONSE_DELETE_COMMENT',
    },
  },

  history: {
    RESPONSE_SELECT_EVENT_HISTORY: 'history/RESPONSE_SELECT_EVENT_HISTORY'
  },

  game: {
    CONNECT: 'game/CONNECT',
    INITIALIZE: 'game/INITIALIZE',
    RECEIVE_SERVER_TIME: 'game/RECEIVE_SERVER_TIME',
    RECEIVE_GROUPS: 'game/RECEIVE_GROUPS',
    RECEIVE_GROUP: 'game/RECEIVE_GROUP',
    RECEIVE_GAME_ROOMS: 'game/RECEIVE_GAME_ROOMS',
    RECEIVE_GAME_ROOM: 'game/RECEIVE_GAME_ROOM',
    RECEIVE_CHAT_MESSAGE: 'game/RECEIVE_CHAT_MESSAGE',
    RECEIVE_GROUP_CHAT_MESSAGE: 'game/RECEIVE_GROUP_CHAT_MESSAGE',
    REQUEST_PASSWORD: 'game/REQUEST_PASSWORD',
    CLOSE_REQUEST_PASSWORD_DIALOG: 'game/CLOSE_REQUEST_PASSWORD_DIALOG',
    MAKE_URL: 'game/MAKE_URL'
  },

  live: {
    CONNECT: 'live/CONNECT',
    INITIALIZE: 'live/INITIALIZE',
    RECEIVE_LIVE_ID: 'live/RECEIVE_LIVE_ID',
    RECEIVE_LATEST_BOARD_CONTEXT: 'live/RECEIVE_LATEST_BOARD_CONTEXT',
    RECEIVE_UPDATE_BOARD_CONTEXT: 'live/RECEIVE_UPDATE_BOARD_CONTEXT',
    REQUEST_SELECT_BOARD_CONTEXT: 'live/REQUEST_SELECT_BOARD_CONTEXT',
    RECEIVE_SELECT_BOARD_CONTEXT: 'live/RECEIVE_SELECT_BOARD_CONTEXT',
    RECEIVE_USER_TYPE: 'live/RECEIVE_USER_TYPE',
    RECEIVE_ADD_CHAT_MESSAGE: 'live/RECEIVE_ADD_CHAT_MESSAGE',
    RECEIVE_ALL_CHAT_MESSAGE: 'live/RECEIVE_ALL_CHAT_MESSAGE',
    RECEIVE_LIVE_STATUS: 'live/RECEIVE_LIVE_STATUS',
    RECEIVE_JOINING_USERS_IN_ROOM: 'live/RECEIVE_JOINING_USERS_IN_ROOM',
  },

  paypal: {
    INIT: 'paypal/INIT',
    CHANGED_PLAN: 'paypal/CHANGE_PLAN',
    CHANGED_AMOUNT: 'paypal/CHANGED_AMOUNT',
  },

  REQUEST_ERROR_MESSAGE_POST: 'REQUEST_ERROR_MESSAGE_POST',
  RECEIVE_ERROR_MESSAGE_POST: 'RECEIVE_ERROR_MESSAGE_POST',
}


// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js